import { render, staticRenderFns } from "./LogisticsInformation.vue?vue&type=template&id=0ac91d79&scoped=true"
import script from "./LogisticsInformation.vue?vue&type=script&lang=js"
export * from "./LogisticsInformation.vue?vue&type=script&lang=js"
import style0 from "./LogisticsInformation.vue?vue&type=style&index=0&id=0ac91d79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac91d79",
  null
  
)

export default component.exports